import React from "react";
import { Container } from "react-bootstrap";
import "./Teamup.css";
const TeamUp = () => {
  return (
    <div>
      <Container className="text-center text-white teamup team-heighr mt-4 d-flex align-items-center justify-content-center ">
        <div className="opacity-team p-4">
          <h4 className="mt-2">TEAM CHALLENGES</h4>
          <h1 className="text">PARTNER UP - DOUBLE POWER</h1>
        </div>
      </Container>
    </div>
  );
};

export default TeamUp;
